export default function PHP_getcwd() {
  return (
    <div>
      <h1>PHP_getcwd</h1>
    </div>
  );
}
